import React, { Component } from 'react';
import FormField from '../SignUp/FormField/FormField';
import environment from '../../environment';
import isFunction from 'lodash/isFunction';
import { connect } from 'react-redux';
import { changeLoginStatus } from '../../actions/index';
import get from 'lodash/get';
import Tooltip from 'rc-tooltip';
import ReCAPTCHA from 'react-google-recaptcha';
import { getNestedErrorMessage } from '../../util';
import {
  Container,
  Holder,
  PasswordResetBox,
  FormContainer,
  Title,
  FormItem,
  ServerErrorMessage,
  SubmitButton,
  RememberPasswordContainer,
  InfoIcon,
  ReCAPTCHAWrapper,
  ReCaptchaError,
  ServerError,
} from './ResetPassword.styles';
import { handleError } from 'services/ErrorService/ErrorService';
import makeCloudFunctionRequest from 'api/makeCloudFunctionRequest';
import SimplrLogo from '../common/SimplrLogo';
import { SimplrLogoWrapper } from '../AuthLayout/Old/AuthLayout.styles';
import { electricBlue } from '../common/colorConstants';
import { ResetLink } from '../LoginPage/LoginPage.styles';
import makeRequest from '../../api/makeRequest';
import * as SimplrErrors from '@asurion-core/typescript-utils/SimplrErrors';
const SimplrPassword = require('@asurion-core/typescript-utils/SimplrPassword');

const simplrPasswordValidator = new SimplrPassword.SimplrADPasswordValidator();

class ResetPassword extends Component {
  state = {
    email: '',
    password: '',
    passwordVerify: '',
    googleRecaptcha: '',
    errors: {},
    done: false,
    token: '',
    accountType: 'expert',
  };

  constructor(props) {
    super(props);
    this.googleReCaptchaRef = React.createRef();
  }

  componentDidMount() {
    let url = window.location.href;

    let accountType = get(this.props, 'match.params.accountType');
    if (accountType !== 'business') {
      accountType = 'expert';
    }

    this.setState({
      token: url.split('token=')[1],
      accountType,
    });
  }

  handleChangeReCaptcha = (googleRecaptcha) => {
    const errors = { ...this.state.errors };
    errors.googleRecaptcha = '';
    this.setState({ googleRecaptcha, errors });
  };

  resetCaptcha = () => {
    if (
      this.googleReCaptchaRef &&
      this.googleReCaptchaRef.current &&
      isFunction(this.googleReCaptchaRef.current.reset)
    ) {
      this.googleReCaptchaRef.current.reset();
    }
  };

  sendPasswordResetEmail = async () => {
    const params = {
      accountType: this.state.accountType,
      email: this.state.email,
      googleRecaptcha: this.state.googleRecaptcha,
    };

    try {
      await makeCloudFunctionRequest('sendPasswordResetEmail', params);
      alert('Email successfully sent!');
      this.props.history.push('/login');
    } catch (error) {
      handleError({ error, customMessage: 'sendPasswordResetEmail failed' });
      // not displaying this error to the user but keeping as is in case we want to display in the future.
      this.setState(
        { errors: { serverError: getNestedErrorMessage(error, 'Send password reset email failed.') } },
        this.resetCaptcha
      );
    }
  };

  resetExpertPassword = async () => {
    const params = {
      accountType: this.state.accountType,
      token: this.state.token,
      newPassword: this.state.password,
      newPasswordRepeat: this.state.passwordVerify,
      googleRecaptcha: this.state.googleRecaptcha,
    };

    try {
      const url = `${environment.services.authServiceUrl}/v1/resetPassword`;
      await makeRequest(url, { data: params, method: 'POST' });
      alert('Password successfully updated!');
      this.props.history.push('/login');
    } catch (error) {
      handleError({ error, customMessage: 'resetExpertPassword failed' });
      // not displaying this error to the user but keeping as is in case we want to display in the future.
      const errors =
        error?.data?.code === SimplrErrors.Codes.WEAK_PASSWORD
          ? {
              password: error.data.fieldErrors[0],
            }
          : {
              serverError: getNestedErrorMessage(error, 'Password invalid or repeats an old password.'),
            };

      this.setState(
        {
          errors,
        },
        this.resetCaptcha
      );
    }
  };

  setValue = (e, field) => {
    e.preventDefault();
    this.setState({ [field]: e.target.value });
  };

  runChecks = () => {
    const errors = {};
    this.setState({ errors: {} });

    // googleRecaptcha
    if (environment.google.isGoogleReCaptchaEnabled && !this.state.googleRecaptcha) {
      errors.googleRecaptcha = 'Please confirm you are not a robot';
    }

    // email
    if (!/\S+@\S+\.\S+/.test(this.state.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (this.state.token) {
      // password
      const passwordValidation = simplrPasswordValidator.validate(this.state.password, this.state.email);

      if (passwordValidation.status !== SimplrPassword.types.PasswordValidationStatus.VALID) {
        errors.password = passwordValidation.errors[0].message;
      }

      if (this.state.password !== this.state.passwordVerify) {
        errors.passwordVerify = 'Passwords should match';
      }
    }

    this.setState({ errors });

    if (Object.keys(errors).length === 0) {
      this.setState({ done: true });
      if (this.state.token) {
        this.resetExpertPassword();
      } else {
        this.sendPasswordResetEmail();
      }
    }
  };

  render() {
    let action;
    let formComponents;
    const title = `Reset ${this.state.accountType.toLowerCase()} password`;
    if (this.state.token) {
      action = 'Reset Password';
      formComponents = (
        <>
          <FormItem>
            <FormField
              error={this.state.errors}
              setValue={this.setValue}
              field="email"
              value={this.state.email}
              placeholder="Email"
              inputType="text"
            />
          </FormItem>

          <FormItem>
            <FormField
              subtitle="10 characters | 1 uppercase | 1 lowercase | 1 digit"
              error={this.state.errors}
              setValue={this.setValue}
              field="password"
              value={this.state.password}
              placeholder="Enter password"
              inputType="password"
            />
          </FormItem>

          <FormItem>
            <FormField
              error={this.state.errors}
              setValue={this.setValue}
              field="passwordVerify"
              value={this.state.passwordVerify}
              placeholder="Re-type password"
              inputType="password"
            />
          </FormItem>
          <Tooltip
            placement="bottom"
            overlay={'10 characters | 1 uppercase | 1 lowercase | 1 digit'}
            arrowContent={<div className="rc-tooltip-arrow-inner" />}
          >
            <InfoIcon
              passwordError={this.state.errors.password}
              passwordVerifyError={this.state.errors.passwordVerify}
              src="/images/info_icon.svg"
              alt="info-icon"
            />
          </Tooltip>
        </>
      );
    } else {
      action = 'Send Email';
      formComponents = (
        <FormItem>
          <FormField
            error={this.state.errors}
            setValue={this.setValue}
            field="email"
            value={this.state.email}
            placeholder="Email"
            inputType="text"
          />
        </FormItem>
      );
    }

    const loginLink =
      this.state.accountType === 'business' ? (
        <ResetLink to="/business">Log in now!</ResetLink>
      ) : (
        <ResetLink to="/login">Log in now!</ResetLink>
      );

    return (
      <Container>
        <Holder>
          <PasswordResetBox>
            <SimplrLogoWrapper>
              <SimplrLogo color={electricBlue} />
            </SimplrLogoWrapper>
            <FormContainer>
              <Title>{title}</Title>
              {formComponents}
              <ReCAPTCHAWrapper hidden={!environment.google.isGoogleReCaptchaEnabled} data-testid={'recaptcha'}>
                <ReCAPTCHA
                  sitekey={environment.google.googleReCaptchaClientKey}
                  onChange={this.handleChangeReCaptcha}
                  name="googleRecaptcha"
                  value={this.state.googleRecaptcha}
                  ref={this.googleReCaptchaRef}
                />
              </ReCAPTCHAWrapper>
              {!!this.state.errors.googleRecaptcha && (
                <ReCaptchaError>{this.state.errors.googleRecaptcha}</ReCaptchaError>
              )}
              <ServerErrorMessage hide={!this.state.errors.serverError}>
                <ServerError>{this.state.errors.serverError}</ServerError>
              </ServerErrorMessage>
              <RememberPasswordContainer>Remember your password? &nbsp;{loginLink}</RememberPasswordContainer>
            </FormContainer>
            <SubmitButton onClick={this.runChecks}>{action}</SubmitButton>
          </PasswordResetBox>
        </Holder>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    changeLoginStatus: (isLoggedIn) => dispatch(changeLoginStatus(isLoggedIn)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
